export enum FlagSeverity {
  red = 'red',
  yellow = 'yellow',
}
